import React from 'react';

/**
 * ResourcesList Component
 * 
 * Displays the tool resources in the exact same structure as the legacy HTML site.
 */
const ResourcesList = ({ resources }) => {
  if (!resources || resources.length === 0) return null;

  // In the legacy site, resources were displayed in the ToolInfoTable
  // This component is only used when we need to show resources separately
  return (
    <div className="tool-resources">
      <div className="tool-resources-wrap">
        <div className="tool-resources-title">Resources</div>
      </div>
      <div className="tool-resources-list">
        {resources.map((resource, index) => (
          <div key={`resource-${index}`} className="tool-resource">
            {resource.type === 'pdf' && (
              <>
                <i className="far fa-file-pdf">&nbsp;&nbsp;</i>
                <a 
                  href={resource.href} 
                  className="link-table"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  PDF
                </a>
              </>
            )}
            {resource.type === 'miro' && (
              <>
                <i className="fas fa-chalkboard"></i>&nbsp;&nbsp;
                <a 
                  href={resource.href} 
                  className="link-table"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Miro
                </a>
              </>
            )}
            {!['pdf', 'miro'].includes(resource.type) && (
              <>
                <i className="fas fa-link"></i>&nbsp;&nbsp;
                <a 
                  href={resource.href} 
                  className="link-table"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {resource.title || resource.type || 'Link'}
                </a>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

/**
 * Helper function to get appropriate icon for resource type
 */
const getResourceIcon = (type) => {
  switch (type) {
    case 'pdf':
      return '📄';
    case 'miro':
      return '📋';
    case 'figma':
      return '🎨';
    case 'link':
      return '🔗';
    default:
      return null;
  }
};

/**
 * Helper function to get appropriate label for resource type
 */
const getResourceLabel = (type, customText) => {
  if (customText) return customText;
  
  switch (type) {
    case 'pdf':
      return 'PDF Template';
    case 'miro':
      return 'Miro Board';
    case 'figma':
      return 'Figma Design';
    case 'link':
      return 'External Resource';
    default:
      return 'Resource';
  }
};

export default ResourcesList; 